var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.146 17.9556L14.0583 13.8679M8.74903 3.86011C11.3439 3.86011 13.4475 5.9637 13.4475 8.5586M16.2666 8.5586C16.2666 12.7105 12.9009 16.0762 8.74903 16.0762C4.59718 16.0762 1.23145 12.7105 1.23145 8.5586C1.23145 4.40675 4.59718 1.04102 8.74903 1.04102C12.9009 1.04102 16.2666 4.40675 16.2666 8.5586Z",
    stroke: "#131313",
    strokeOpacity: 0.7,
    strokeWidth: 1.8794,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d0448bd1ee3e434c39f6e9584543eb92.svg";
export { ForwardRef as ReactComponent };